import React, {Component} from 'react';
import {Container, Table} from "reactstrap";
import AppActions from './../actions/AppActions';
import {get} from './../lib/http';
import _ from 'lodash';
import Pager from "./Pager";
import {Link} from "react-router-dom";
import moment from "moment";

const pageSize = 20;

export class SpatialAnchors extends Component {
    componentWillMount() {
        const {skip} = this.props;

        this.update(skip || 0);
    }

    render() {
        const {anchors, total, skip} = this.props;

        const rows = _.map(anchors, anchor => <tr key={anchor.id}>
            <td>{anchor.id}</td>
            <td>{moment.utc(anchor.dateTimeCreatedUtc).local().format("DD/MM/YYYY H:mm:ss")}</td>
            <td>{anchor.data}</td>
            <td>
                <Link className="float-right" to={`spatial-anchor/${anchor.id}`}>Edit</Link>
            </td>
        </tr>);

        const mixId = window.localStorage.getItem('mixId') || '';

        return (
            <Container fluid>
                <h1>Spatial Anchors</h1>

                <a className="float-right" href={`https://mixiply.com/app/mix/${mixId}`} rel="noopener noreferrer" target="_blank">Mix
                    id: {mixId}</a>
                <div className="clearfix"/>
                <Table size="sm" hover className="mt-3">
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Created</th>
                        <th>Data</th>
                        <th className="btn-col">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </Table>

                <Pager pageSize={pageSize} total={total} skip={skip} onPageSelected={(skip) => this.update(skip)}/>
            </Container>
        );
    }

    update(skip) {
        const mixId = window.localStorage.getItem('mixId') || '';

        get('api/anchors/paged/:mixId', {skip: skip, mixId}, (data) => {
            AppActions.updateStates([
                {statePath: 'skip', data: skip || 0},
                {statePath: 'anchors', data: data.items},
                {statePath: 'total', data: data.total}
            ]);
        });
    }
}